import * as Type from 'library/ts/utilities/modules/Type';
export const filterRange = (array, min, max, propertyName) => {
    const len = array.length;
    let up = -1;
    let down = len;
    let rrange = [];
    const mid = Math.floor(len / 2);
    while (up++ < mid && down-- > mid) {
        if ((array[up][propertyName] || array[up]) >= max || (array[down][propertyName] || array[down]) <= min) {
            break;
        }
        if ((array[up][propertyName] || array[up]) >= min) {
            rrange.push(array[up]);
        }
        if ((array[down][propertyName] || array[down]) <= max) {
            rrange.push(array[down]);
        }
    }
    rrange = removeDuplicates(rrange, 'bitrate');
    return rrange;
};
export const removeDuplicates = (array, propertyName = undefined) => {
    if (propertyName === undefined) {
        return array.filter((item, index) => array.indexOf(item) === index);
    }
    const new_arr = [];
    const lookup = {};
    for (const i in array) {
        lookup[array[i][propertyName]] = array[i];
    }
    for (const i in lookup) {
        new_arr.push(lookup[i]);
    }
    return new_arr;
};
export const sortByProperty = (propertyName, ascending = true) => {
    return (a, b) => {
        let sortStatus = 0;
        if (a[propertyName] < b[propertyName]) {
            sortStatus = (ascending === true ? -1 : 1);
        }
        else if (a[propertyName] > b[propertyName]) {
            sortStatus = (ascending === true ? 1 : -1);
        }
        return sortStatus;
    };
};
export const search = (keyName, keyValue, myArray = []) => {
    if (Type.isEmpty(keyName) || Type.isEmpty(keyValue) || Type.isEmpty(myArray))
        return null;
    for (let i = 0; i < myArray.length; i++) {
        if (myArray[i][keyName] === keyValue) {
            return myArray[i];
        }
    }
    return null;
};
export const indexOf = (keyName, keyValue, myArray) => {
    for (let i = 0; i < myArray.length; i++) {
        if (myArray[i][keyName] === keyValue) {
            return i;
        }
    }
    return null;
};
export const hasObjWithPropValue = (array, key, valueToCheck) => {
    let found = false;
    array.some((item) => {
        if (item[key] === valueToCheck) {
            found = true;
            return true;
        }
    });
    return found;
};
export const swapItems = (indexA, indexB, array) => {
    const temp = array[indexA];
    array[indexA] = array[indexB];
    array[indexB] = temp;
    return array;
};
export const moveItem = (array, from, to) => {
    const element = array.splice(from, 1)[0];
    array.splice(to, 0, element);
    return array;
};
